import { currentWorld, worlds, type ReadyWorldId } from './worlds'
import { CityIllustration } from './CityIllustration'
import { ct } from '../competition/localization'

export function WorldPicker({selected,onChoose,language='en-US'}:{selected:string|undefined;onChoose:(id:ReadyWorldId)=>void;language?:string}){
  const active=currentWorld(selected)
  const tr=(text:string,values:Record<string,string|number>={})=>ct(language,text,values)
  return <section className="settings-section world-picker" aria-labelledby="world-picker-title">
    <div className="world-picker-heading"><div><h2 id="world-picker-title">{tr('3D worlds')}</h2><p>{tr('Choose a city to explore. Your progress travels with you.')}</p></div><span>{tr('{ready} of {total} ready',{ready:worlds.filter(world=>world.ready).length,total:worlds.length})}</span></div>
    <div className="world-grid">{worlds.map((world,index)=><button
      key={world.id}
      type="button"
      className={`world-choice ${active.id===world.id?'selected':''}`}
      disabled={!world.ready}
      aria-pressed={world.ready?active.id===world.id:undefined}
      title={world.ready?tr('Explore {city}',{city:world.name}):tr('{city} is coming soon',{city:world.name})}
      onClick={()=>world.ready&&onChoose(world.id as ReadyWorldId)}
    ><span className="world-choice-art"><CityIllustration id={world.id}/><span className="world-choice-number">{String(index+1).padStart(2,'0')}</span></span><span className="world-choice-label"><b>{world.name}</b><small>{tr(world.place)}</small><span className="world-choice-status">{tr(world.ready?(active.id===world.id?'Selected':'Explore'):'Coming soon')}</span></span></button>)}</div>
  </section>
}
